import { render, staticRenderFns } from "./projects.vue?vue&type=template&id=3af279a7&scoped=true"
import script from "./projects.vue?vue&type=script&lang=js"
export * from "./projects.vue?vue&type=script&lang=js"
import style0 from "./projects.vue?vue&type=style&index=0&id=3af279a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af279a7",
  null
  
)

export default component.exports